import bundleJson from "./legal-documents.bundle.json";

export const TERMS_DOCUMENT_VERSION = "2026-08-10.1";
export const PRIVACY_DOCUMENT_VERSION = "2026-08-10.1";
export const LEGAL_DOCUMENT_STATUS = "DRAFT_EXTERNAL_LEGAL_APPROVAL_REQUIRED";
export const LEGAL_DOCUMENT_SCHEMA_VERSION = 1;

export type LegalDocumentKind = "terms" | "privacy";

export interface LegalSection {
  heading: string;
  paragraphs: string[];
  items: string[];
}

export interface LegalDocument {
  kind: LegalDocumentKind;
  title: string;
  version: string;
  status: string;
  summary: string;
  sections: LegalSection[];
}

interface LegalDocumentBundle {
  schema_version: number;
  approval_status: string;
  documents: Record<LegalDocumentKind, LegalDocument>;
}

const bundle = bundleJson as unknown as LegalDocumentBundle;

if (
  bundle.schema_version !== LEGAL_DOCUMENT_SCHEMA_VERSION ||
  bundle.approval_status !== LEGAL_DOCUMENT_STATUS ||
  bundle.documents.terms.version !== TERMS_DOCUMENT_VERSION ||
  bundle.documents.privacy.version !== PRIVACY_DOCUMENT_VERSION
) {
  throw new Error(
    "The bundled legal documents do not match the client contract",
  );
}

export const legalDocuments = bundle.documents;

export function legalDocument(kind: LegalDocumentKind) {
  return legalDocuments[kind];
}
